import Image from "next/image";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/Contentview.module.css';

const RelatedArticle = ({ data, header, onclick }) => {

    if (data && data.length > 0) {
        let rows = [];

        //iterate & construct the cards
        for (let r = 0; r < data.length; r++) {
            const article = data[r];
            rows.push(
                <Row className={styles.relatedCard} key={r} onClick={() => onclick(article)}>
                    <Col lg={5} md={5} className={styles.thumbnailHolder}>
                        <Image 
                            src={article.thumbnail} 
                            alt="圖片"
                            sizes="100vw"
                            className={styles.thumbnail}
                            height={0}
                            width={0}
                            style={{
                                width: '100%',
                                height: 'auto',
                            }}
                        />
                    </Col>
                    <Col lg={7} md={7} className={styles.textHolder}>
                        <div className={styles.textInnerHolder}>
                            <div className={styles.rowTitle}>{article.title}</div>
                            <div className={styles.rowExcerpt}>{article.excerpt}</div>
                            <div className={styles.rowDate}>
                                {article.post_date && article.post_date.substring(0, 10)}
                            </div>
                        </div>
                    </Col>
                </Row>
            );
        }

        return (
            <div className={styles.relatedArticle}>
                <Container style={{ padding: 0 }}>
                    <Row className={styles.relatedHolder}>
                        <Col lg={5} md={12} className={styles.cardCol}>
                            <div className={styles.relatedHeader}>{header}</div>
                        </Col>
                        <Col lg={7} className={styles.cardCol}>
                            <div className={styles.relatedDivider}></div>
                        </Col>
                    </Row>
                    {rows}
                </Container>
            </div>
        );
    }

    return <></>
}

export default RelatedArticle;